import React from 'react';

import styled from 'styled-components';

import useFooterLines from '@hooks/Layout/UseFooterLines';

import PrintableFooter from './PrintableFooter';
import PrintableHeader from './PrintableHeader';

const PrintableTableWrapper = styled.table`
    width: 100%;

    .content {
        width: 100%;
    }

    @media print {
        .header,
        .header-space {
            height: 100px;
        }
        ${({ $showFooter }) =>
            $showFooter &&
            `
        .footer,
        .footer-space {
            height: 70px;
        }
        `}
    }
`;

const PrintableLayout = ({
    children,
    showCompanyHeader = true,
    showCompanyFooter = true,
    onlyLogoInHeader = false,
}) => {
    const footerLines = useFooterLines();
    const hasFooter = showCompanyFooter && footerLines.length > 0;

    return (
        <>
            {showCompanyHeader && <PrintableHeader onlyLogo={onlyLogoInHeader} />}
            <PrintableTableWrapper $showFooter={hasFooter}>
                {showCompanyHeader && (
                    <thead>
                        <tr>
                            <td>
                                <div className="header-space">&nbsp;</div>
                            </td>
                        </tr>
                    </thead>
                )}
                <tbody>
                    <tr>
                        <td style={{ width: '100%' }}>
                            <div className="content">{children}</div>
                        </td>
                    </tr>
                </tbody>
                {hasFooter && (
                    <tfoot>
                        <tr>
                            <td>
                                <div className="footer-space">&nbsp;</div>
                            </td>
                        </tr>
                    </tfoot>
                )}
            </PrintableTableWrapper>
            {hasFooter && <PrintableFooter />}
        </>
    );
};

export default PrintableLayout;
